import { useMutation } from 'src/graphql';
import { useCallback } from 'react';
import { GENERATE_DATA_FALSIFICATION_EXCEL } from '../../graphql/survey/mutation';

const useGenerateDataFalsificationResultExcel = () => {
  const [generateDataFalsificationResultExcel] = useMutation(
    GENERATE_DATA_FALSIFICATION_EXCEL,
  );

  return useCallback(
    params => generateDataFalsificationResultExcel({ variables: params }),
    [],
  );
};

export default useGenerateDataFalsificationResultExcel;
